import { getRouteApi } from "@tanstack/react-router";
import { loadPreviewSplit } from "./assign-preview-split.ts";
import { markerForArm } from "./preview-split-marker.ts";

const previewSplitRouteApi = getRouteApi("/preview-split");

export function PreviewSplitPage() {
    const { arm, profileId } = previewSplitRouteApi.useLoaderData();
    const marker = markerForArm(arm);
    return (
        <div
            data-preview-split-arm={marker.arm}
            style={{
                alignItems: "center",
                background: marker.background,
                color: marker.color,
                display: "flex",
                flexDirection: "column",
                fontFamily: "sans-serif",
                inset: 0,
                justifyContent: "center",
                position: "fixed",
                zIndex: 80,
            }}
        >
            <p style={{ fontSize: 96, fontWeight: 800, margin: 0 }}>
                {marker.label}
            </p>
            <p style={{ fontSize: 28, marginTop: 16 }}>preview-split</p>
            <p style={{ fontSize: 18, marginTop: 8 }}>{profileId}</p>
        </div>
    );
}

export const previewSplitRoute = {
    loader: () => loadPreviewSplit(),
    head: () => ({
        meta: [{ title: "preview-split" }],
    }),
};
